import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-muted-foreground font-normal"
}
const _hoisted_2 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_3 = { class: "flex gap-3" }
const _hoisted_4 = { class: "flex-1 space-y-2" }
const _hoisted_5 = { class: "flex gap-3" }
const _hoisted_6 = { class: "flex-1 space-y-2" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-8 text-center"
}
const _hoisted_8 = { class: "text-sm text-muted-foreground" }
const _hoisted_9 = { class: "text-xs text-muted-foreground mt-1" }
const _hoisted_10 = { class: "divide-y" }

import { onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCommentsStore } from '../store'
import { useUsersStore } from '@/views/Users/store'
import type { Comment, CommentEntityType } from '@/types'

import CommentItem from './CommentItem.vue'
import CommentForm from './CommentForm.vue'

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import { ScrollArea } from '@/components/ui/scroll-area'
import { MessageSquare } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentsList',
  props: {
    entityType: {},
    entityId: {},
    title: {},
    maxHeight: {}
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()
const commentsStore = useCommentsStore()
const usersStore = useUsersStore()

onMounted(async () => {
  if (usersStore.users.length === 0) {
    await usersStore.fetchUsers()
  }
  await commentsStore.fetchComments(props.entityType, props.entityId)
})

watch(
  () => [props.entityType, props.entityId],
  async ([newType, newId]) => {
    if (newType && newId) {
      await commentsStore.fetchComments(newType as CommentEntityType, newId as string)
    }
  }
)

const handleAddComment = async (content: string, isInternal: boolean) => {
  await commentsStore.createComment({
    entityType: props.entityType,
    entityId: props.entityId,
    content,
    isInternal,
  })
}

const handleEditComment = async (comment: Comment, content: string) => {
  await commentsStore.updateComment(comment.id, { content })
}

const handleDeleteComment = async (comment: Comment) => {
  await commentsStore.deleteComment(comment.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), null, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), { class: "pb-3" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardTitle), { class: "flex items-center gap-2 text-base" }, {
            default: _withCtx(() => [
              _createVNode(_unref(MessageSquare), { class: "h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(__props.title || _unref(t)('comments.title')) + " ", 1),
              (_unref(commentsStore).comments.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(_unref(commentsStore).comments.length) + ") ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(CardContent), { class: "space-y-4" }, {
        default: _withCtx(() => [
          _createVNode(CommentForm, {
            "is-loading": _unref(commentsStore).isLoading,
            onSubmit: handleAddComment
          }, null, 8, ["is-loading"]),
          _createVNode(_unref(Separator)),
          (_unref(commentsStore).isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Skeleton), { class: "h-8 w-8 rounded-full" }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(Skeleton), { class: "h-4 w-32" }),
                    _createVNode(_unref(Skeleton), { class: "h-16 w-full" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Skeleton), { class: "h-8 w-8 rounded-full" }),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(Skeleton), { class: "h-4 w-24" }),
                    _createVNode(_unref(Skeleton), { class: "h-12 w-3/4" })
                  ])
                ])
              ]))
            : (_unref(commentsStore).comments.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(MessageSquare), { class: "h-10 w-10 text-muted-foreground mb-3" }),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('comments.noComments')), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('comments.beFirst')), 1)
                ]))
              : (_openBlock(), _createBlock(_unref(ScrollArea), {
                  key: 2,
                  class: _normalizeClass(__props.maxHeight ? `h-[${__props.maxHeight}]` : ''),
                  style: _normalizeStyle(__props.maxHeight ? { maxHeight: __props.maxHeight } : {})
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commentsStore).comments, (comment) => {
                        return (_openBlock(), _createBlock(CommentItem, {
                          key: comment.id,
                          comment: comment,
                          onEdit: handleEditComment,
                          onDelete: handleDeleteComment
                        }, null, 8, ["comment"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["class", "style"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})